// Kick off the application.
require([
  'app',
  'settings',
  'jquery',
  'require',
  'translation',
  'trumbowyg'
], function(
  App,
  Settings,
  $,
  require,
  Translation
) {
  'use strict';

  // One-shot cleanup: Plivo's logger persists a huge log buffer under
  // 'PlivoLogStorage' that was filling users' localStorage quota. Strip it
  // on every app boot so it can never grow back.
  try { window.localStorage.removeItem('PlivoLogStorage'); } catch (e) { /* no-op */ }

  // Restore the user's dark-mode preference before anything renders so
  // returning users don't get a flash of light theme. The toggle lives
  // in the header view (onToggleTheme).
  try {
    if (window.localStorage.getItem('compuzz-dark-mode') === '1') {
      document.body.classList.add('dark-mode');
    }
  } catch (e) { /* localStorage disabled — fall back to light theme */ }

  Translation.fetchTranslations().done(function() {
    require(['router', 'secondScreenBridge'], function(Router, SecondScreen){
      //start the application
      App.start();
      // Let this window receive routes pushed from another dashboard window
      // (e.g. the Sales Inbox pushing a customer's board to the second screen).
      SecondScreen.listen();
      $.trumbowyg.svgPath = '/vendors/ui/icons.svg';
    });
  } ).fail(function() {
      window.location.href = Settings.serverUrl + 'server-unavailable.html';
  } );
});

define("main", function(){});

